export default __webpack_public_path__ + "static/cert-7-bfbe58084d0006a4510f6e7a10474beb.png";